import { BaseJs } from '@gate31/core/src/libs/BaseJsComponents';
import { CustomCn } from '@gate31/core/src/libs/classname';
import { LiquidTemplates } from '@gate31/uikit/common/scripts/liquid-render';
import { InsalesProduct } from '@gate31/feature/InsalesProduct/InsalesProduct';
import { disableBodyScroll, enableBodyScroll } from 'body-scroll-lock';
import Swiper from 'swiper';

export class ProductModalGallerySliderDesk extends BaseJs {
    static cn = new BaseJs.BuildCn('ProductModalGallerySliderDesk');

    triggerCn: CustomCn;
    closeButtonCn: CustomCn;
    product: InsalesProduct;
    headerWrapper: HTMLDivElement;

    swiper: Swiper | undefined;

    constructor({ template, product, headerWrapper }: { template: keyof LiquidTemplates; product: InsalesProduct; headerWrapper: HTMLDivElement }) {
        super(template);

        this.triggerCn = ProductModalGallerySliderDesk.cn.setElem('trigger');
        this.closeButtonCn = ProductModalGallerySliderDesk.cn.setElem('close');
        this.product = product;
        this.headerWrapper = headerWrapper;

        this.swiper;

        this.connectionCallback();
    }

    connectionCallback() {
        document.addEventListener('click', e => {
            const target = e.target as HTMLElement;
            const currentNode = target.closest(this.triggerCn.toSelector());

            if (currentNode) {
                const imageIndex = Number(currentNode.getAttribute('data-index-progger') as string || 0);

                this.openModal();
                this.initSlider(imageIndex);
                this.handleClose();
            }
        });
    }

    handleClose() {
        const buttonClose = this.findElem<HTMLDivElement>(this.closeButtonCn.toSelector());

        buttonClose.addEventListener('click', () => {
            enableBodyScroll(this.getRoot());
            this.getRoot().remove();
        });
    }

    initSlider(index: number) {
        this.swiper = new Swiper(ProductModalGallerySliderDesk.cn.setElem('slider').toSelector(), {
            loop: true,
            initialSlide: index || 0,
            slidesPerView: 1,
            navigation: {
                nextEl: ProductModalGallerySliderDesk.cn.setElem('btn-next').toSelector(),
                prevEl: ProductModalGallerySliderDesk.cn.setElem('btn-prev').toSelector()
            }
        });
    }

    openModal() {
        this.renderTemplate({
            container: this.headerWrapper,
            templateData: {
                images: this.product.product.images
            }
        });

        disableBodyScroll(this.getRoot());
    }
}
